import { cn } from '@/utils/shadcn/utils'

export const DialogContentContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('flex flex-col gap-4 p-6', className)} {...props}>
      {children}
    </div>
  )
}

export const PriceRow: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('flex flex-col gap-2', className)} {...props}>
      {children}
    </div>
  )
}

export const DialogFooterContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn('flex justify-end gap-3 p-6 pt-0', className)}
      {...props}
    >
      {children}
    </div>
  )
}
